<template>
	<div id="InventoryRunComponent" class="inventory-run-component">
		<button ref="btnGetInventoryTemplatesEmployeeLocal" @click="getInventoryTemplatesEmployeeLocal()">Buscar Planillas</button>
		<div v-if="this.objectEmployee.id == 0">
			<select class="form-control form-control-sm" v-model="employeeIdSelected">
				<option disabled selected hidden value="0">Quien soy</option>
				<option v-for="(item, index) in listEmployees" :key="index" :value="item.id">{{ item.surname }} {{ item.name }}</option>
			</select>
			<br>
			<input type="text" maxlength="4" class="form-control form-control-sm" placeholder="4 digitos RUT"
				:disabled="!(employeeIdSelected > 0)"
				v-model="document_number4"
				@keypress.enter="checkEmployee()"/>
			<br>
			<button class="btn btn-sm btn-primary btn-block" :disabled="!(employeeIdSelected > 0) || (document_number4.trim().length < 4)" @click="checkEmployee">Entrar</button>
		</div>
		<div v-else>
			<div>
				<span>Nombre: </span>
				<label>{{objectEmployee.name}} {{objectEmployee.surname}}</label>
				<i class="far fa-edit pointer text-warning float-right" @click="clearObjectEmployeeLocal" title="cambiar de trabajador"></i>
			</div>
			<div v-if="!showingInventoryTemplate">
				<div v-if="inventoryTemplateSelected == 0">
					<div v-if="!loadingInventoryTemplates">
						<div class="p-2 bg-info mb-1" v-for="(item, index) in listInventoryTemplates" :key="index" @click="showInventoryTemplateEmployeeLocal(item.id)">
							<div>{{item.name}}</div>
							<div><small>{{item.inventory_template_store_rack_side_row_column[0].store.name}} {{item.inventory_template_store_rack_side_row_column[0].store_rack.name}} {{item.inventory_template_store_rack_side_row_column[0].store_rack_side.name}}</small></div>
						</div>
						<div v-if="listInventoryTemplates.length == 0" class="text-center">
							<div v-if="inventoryId == undefined">
								No se ha establecido un periodo de inventario
							</div>
							<div v-else>
								No hay planillas asignadas.
							</div>
						</div>
					</div>
					<div v-else class="text-center">
						Buscando planillas...
					</div>
				</div>
				<div v-else>
					<div class="border-top pt-2">
						<span>Ubicacion: </span>
						<label>{{objectInventoryTemplate.inventory_template_store_rack_side_row_column[0].store.name}} {{objectInventoryTemplate.inventory_template_store_rack_side_row_column[0].store_rack.name}} {{objectInventoryTemplate.inventory_template_store_rack_side_row_column[0].store_rack_side.name}}</label>
						<i class="far fa-edit pointer text-warning float-right" @click="inventoryTemplateSelected = 0" title="Cambiar de planilla"></i>
					</div>
					<table class="table table-sm table-striped table-12">
						<thead>
							<tr>
								<th>Articulo</th>
								<th>Modulo</th>
								<th class="text-right">Cantidad</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in inventoryTemplatedetailFilter" :key="index" @click="enterQuantity(item)">
								<td class="align-middle">
									<p>{{ item.product.name }}</p>
									<small>Cod: {{ item.product.id }} | ISBN: {{ item.product.isbn }}</small>
								</td>
								<td class="text-center align-middle">{{ item.store_rack_side_row_column.name }}{{ item.store_rack_side_row_column.store_rack_side_row.name }}</td>
								<td class="align-middle text-right" v-show="isEmployeeCount(1)">
									{{ methodFormatNumber(item.count_1) }}
								</td>
								<td class="align-middle text-right" v-show="isEmployeeCount(2)">
									{{ methodFormatNumber(item.count_2) }}
								</td>
								<td class="align-middle text-right" v-show="isEmployeeCount(3)">
									{{ methodFormatNumber(item.count_3) }}
								</td>
								<td class="align-middle text-right" v-show="isEmployeeCount(4)">
									{{ methodFormatNumber(item.count_4) }}
								</td>
							</tr>
							<tr>
								<td class="text-center" colspan="3"><span class="btn btn-link btn-sm pointer" @click="addNewProductLocal">Agregar Articulo</span></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div v-else>
				Cargando planilla...
			</div>
		</div>
		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#enterQuantityModal" ref="btnShowEnterQuantityModal" v-show="false">
			Ingresar Cantidad
		</button>

		<!-- Modal -->
		<div class="modal fade" id="enterQuantityModal" tabindex="-1" aria-labelledby="enterQuantityModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content" v-if="objectInventoryTemplateDetail.id > 0">
					<div class="modal-header">
						<h5 class="modal-title" id="enterQuantityModalLabel">Codigo Articulo ({{objectInventoryTemplateDetail.product.id}})</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row mb-2">
							<div class="col-4 text-center">
								<img :src="objectInventoryTemplateDetail.product.img" width="100%" v-if="objectInventoryTemplateDetail.product.img != null && objectInventoryTemplateDetail.product.img != ''">
								<img src="/img/img-not-found.png" width="100%" v-else title="No tiene imagen asignada">
							</div>
							<div class="col-8 align-middle">
								<p>{{objectInventoryTemplateDetail.product.name}}</p>
								<p>ISBN {{objectInventoryTemplateDetail.product.isbn}}</p>
							</div>
						</div>
						<br>
						<div class="text-center">
							<label for="quantityInput" ref="quantityInput">Cantidad</label>
						</div>
						<div class="text-center">
							<input readonly type="text"
								class="text-center"
								id="quantityInput"
								v-model="objectInventoryTemplateDetail['count_'+ countIndexEmployee]" style="font-size:48px; width:200px; border:1px solid #ddd"
								v-on:keyup.enter="updateCount(countIndexEmployee, objectInventoryTemplateDetail)">
						</div>
						<br>
						<div class="text-center">
							<numeric-keyboard-component @clickDigit="enterNumber" extra1="Limpiar" class_extra1="digit-small-small" extra2="Borrar" class_extra2="digit-small-small"></numeric-keyboard-component>
						</div>
						<div class="text-center" v-if="objectInventoryTemplateDetail.store_rack_side_row_column">
							{{ objectInventoryTemplateDetail.store_rack_side_row_column.store.name }}
							{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack.name }}
							{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack_side.name }}
							{{ objectInventoryTemplateDetail.store_rack_side_row_column.name }}{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack_side_row.name }}
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btb-sm" data-dismiss="modal" ref="btnCloseEnterQuantityModal">Cerrar</button>
						<button type="button" class="btn btn-primary btb-sm"
							:disabled="objectInventoryTemplateDetail.inventory_template_store_rack_module_product_id == 0 || objectInventoryTemplateDetail.quantity < 1 || savingInventoryTemplateStoreRackModuleProductQuantity" 
							@click="updateCount(countIndexEmployee, objectInventoryTemplateDetail)">
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>

				<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#addProductModal" ref="btnShowAddProductModal" v-show="false">
			Nuevo articulo
		</button>

		<!-- Modal -->
		<div class="modal fade" id="addProductModal" tabindex="-1" aria-labelledby="addProductModalModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="addProductModalModalLabel">Agregar articulo a la planilla</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div v-show="objectInventoryTemplateDetail.store_rack_side_row_column_id == 0">
							<h6>Seleccionemos el modulo</h6>
							<side-component
								ref="sideComponent"
								:id="storeRackSideIdSelected"
								@actionClickModule="actionClickModuleLocal">
							</side-component>
						</div>
						<div v-show="objectInventoryTemplateDetail.store_rack_side_row_column_id > 0">
							<h6>Busquemos el articulo</h6>
							<input class="form-control form-control-sm" placeholder="ingrese en nombre del articulo aquí" v-model="searchProducts" @keypress="keypressLocal">
							<div class=""mb-2>
								<table class="table table-hover table-sm">
									<thead>
										<tr v-for="(item, index) in listProducts" :key="index" class="pointer" :class="(objectInventoryTemplateDetail.product_id == item.id) ? 'font-weight-bold': ''">
											<td class="align-middle" @click="objectInventoryTemplateDetail.product_id = item.id">
												<p>{{ item.name }}</p>
												<small>Cod: {{ item.id }} | ISBN: {{ item.isbn }}</small>
											</td>
										</tr>
									</thead>
								</table>
							</div>
							<div class="text-center" v-if="objectInventoryTemplateDetail.store_rack_side_row_column_id > 0">
								{{ objectInventoryTemplateDetail.store_rack_side_row_column.store.name }}
								{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack.name }}
								{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack_side.name }}
								{{ objectInventoryTemplateDetail.store_rack_side_row_column.name }}{{ objectInventoryTemplateDetail.store_rack_side_row_column.store_rack_side_row.name }}
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btb-sm" data-dismiss="modal" ref="btnCloseAddProductModal">Cerrar</button>
						<button type="button" class="btn btn-primary btb-sm"
							:disabled="objectInventoryTemplateDetail.product_id == 0 || savingInventoryTemplateDetail" 
							@click="saveObjectInventoryTemplateDetailLocal()">
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import employee from '@/mixins/employees'
import inventoryTemplate from '@/mixins/inventories/inventoryTemplate.js'
import inventoryTemplateDetail from '@/mixins/inventories/inventoryTemplateDetail.js'
import product from '@/mixins/products'

import NumericKeyboardComponent from '@/components/NumericKeyboardComponent.vue'
import SideComponent from '@/components/SideComponent.vue'

export default {
	name: 'InventoryRunComponent',
	mixins: [axiosAction, errors, mixin, employee, inventoryTemplate, product, inventoryTemplateDetail],
	props: ['inventoryId'],
	data () {
		return {
			document_number4: '',
			allProducts: true,
			forCode: false,
			searchProduct: '',
			countIndexEmployee: 0,
			storeRackSideIdSelected: 0,
			inventoryTemplateDetailIdSelected: 0
		}
	},
	components: {
		'side-component': SideComponent,
		'numeric-keyboard-component': NumericKeyboardComponent,
	},
	computed: {
		inventoryTemplatedetailFilter() {
			let list = []
			let searchProduct = this.searchProduct.toLowerCase()
			let strings = searchProduct.split('%')
			let r = true
			let index = -1
			list = this.objectInventoryTemplate.inventory_template_detail.filter(e => {
				r = true
				strings.forEach(el => {
					index = e.product.name.toLowerCase().indexOf(el)
					if(index == -1 && r == true) {
						r = false
					}
				})
				if(!r) {
					r = (parseInt(e.product.id) == strings[0] || e.product.isbn == strings[0])
				}
				if(this.showInventoriesOnly && r) {
					r = (e.count_1 != null || e.count_2 != null || e.count_3 != null || e.count_4 != null)
				}
				return r
			})
			return list
		}
	},
	methods: {
		addNewProductLocal() {
			this.clearObjectInventoryTemplateDetail()
			this.objectInventoryTemplateDetail.inventory_template_id = this.objectInventoryTemplate.id
			this.searchProducts = ''
			this.listProducts = []
			this.$refs.btnShowAddProductModal.click()
		
		},
		actionClickModuleLocal(item) {
			this.objectInventoryTemplateDetail.store_rack_side_row_column_id = item.id
			this.objectInventoryTemplateDetail.store_rack_side_row_column = item
		},
		checkEmployee() {
			if(this.document_number4.trim().length > 3) {
				let index = this.listEmployees.map((el) => parseInt(el.id)).indexOf(parseInt(this.employeeIdSelected))
				if(index > -1) {
					if(this.listEmployees[index].document_number.substring(0, 4) == this.document_number4) {
						localStorage.setItem('employeeIdSelected', this.listEmployees[index].id)
						this.setObjectEmployeeLocal(this.listEmployees[index])
						this.getInventoryTemplatesEmployeeLocal()
					} else {
						alert('No verificado')
					}
				}
			}
		},
		isEmployeeCount(countIndex, returtIndex = false) {
			let index = this.objectInventoryTemplate.inventory_template_employee.map(e => parseInt(e.id)).indexOf(parseInt(this.objectEmployee.id))
			if(index > -1 && parseInt(this.objectInventoryTemplate.inventory_template_employee[index].pivot.count_x) == countIndex)
				return (returtIndex) ? countIndex : true
			return (returtIndex) ? 0 : false
		},
		clearObjectEmployeeLocal() {
			localStorage.removeItem('employeeIdSelected');
			this.document_number4 = ''
			this.employeeIdSelected = 0
			this.inventoryTemplateSelected = 0
			this.clearObjectEmployee()
			this.clearObjectInventoryTemplate()
		},
		deleteInventoryTemplateStoreRackModuleProductQuantityLocal(id) {
			if(confirm('¿Está seguro que quiere eliminar este registro?')) {
				this.deleteInventoryTemplateStoreRackModuleProductQuantity(id)
			}
		},
		deleteInventoryTemplateStoreRackModuleProductQuantityResultLocal(response) {
			if(response.data.success == true) {
				this.objectInventoryTemplate.inventory_template_store_rack_modules.forEach(item => {
					item.inventory_template_store_rack_module_products.forEach(product => {
						if(response.data.data.inventory_template_store_rack_module_product_id == product.inventory_template_store_rack_module_product_id) {
							let index = product.quantities.map((el) => parseInt(el.id)).indexOf(parseInt(response.data.data.id))
							if(index > -1) {
								this.$refs.btnCloseEnterQuantityModal.click()
								product.quantities.splice(index, 1)
							}
						}
					});
				});
			}
		},
		enterQuantity(item, forCode = false) {
			this.clearObjectInventoryTemplateDetail()
			this.setObjectInventoryTemplateDetail(item)
			this.$refs.btnShowEnterQuantityModal.click()
			setTimeout(() => {this.$refs.quantityInput.click()}, 500)
		},
		enterNumber(dig) {
			if(dig == 'Limpiar') {
				this.clearDig()
			} else if (dig == 'Borrar') {
				this.deleteLastDig()
			} else {
				if(this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] == null) {
					this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] = ''
				}
				let str = this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] + "" + dig
				this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] = str
			}
		},
		deleteLastDig() {
			this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee]+= ""
			if(this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee].length > 0) {
				this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] = this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee].substring(0, this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] = this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee].length - 1)
			}
		},
		clearDig() {
			this.objectInventoryTemplateDetail['count_' + this.countIndexEmployee] = ''
		},
		getAllProductsLocal() {
			this.objectInventoryTemplateDetail.product_id = 0
			if(this.searchProducts.length > 2 && this.searchProducts.trim() != '') {
				this.qRowsProduct = 10000
				this.getAllProducts(1)
			}
		},
		initComponentLocal() {
			this.getAllEmployeesLocal()
		},
		getAllEmployeesLocal() {
			this.getAllEmployees()
		},
		getAllEmployeesResultLocal(response) {
			if(localStorage.getItem('employeeIdSelected') != null) {
				let index = this.listEmployees.map((el) => parseInt(el.id)).indexOf(parseInt(localStorage.getItem('employeeIdSelected')))
				if(index > -1) {
					this.setObjectEmployeeLocal(this.listEmployees[index])
					this.getInventoryTemplatesEmployeeLocal()
				}
			}
		},
		getAllProductsResultLocal(response) {
		},
		getInventoryTemplatesEmployeeLocal() {
			if(this.objectEmployee.id > 0 && this.inventoryId != undefined) {
				this.getInventoryTemplatesEmployee(this.objectEmployee.id, this.inventoryId)
			}
		},
		getInventoryTemplatesEmployeeResultLocal(response) {
			
		},
		keypressLocal(e) {
			this.listProducts = []
			this.objectInventoryTemplateDetail.product_id = 0
			if(e.key == 'Enter') {
				this.getAllProductsLocal()
			}
		},
		quantityEmployee(item) {
			let q = ''
			item.inventory_template_store_rack_module_product_quantitys.forEach((quantity) => {
				if(quantity.employee_id == this.objectEmployee.id) {
					q = quantity.quantity
				}
			})
			return q
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'deleteInventoryTemplateStoreRackModuleProductQuantityResult': this.deleteInventoryTemplateStoreRackModuleProductQuantityResult(response); break;
				case 'getAllEmployeesResult': this.getAllEmployeesResult(response); break;
				case 'getAllProductsResult': this.getAllProductsResult(response); break;
				case 'getInventoryTemplatesEmployeeResult': this.getInventoryTemplatesEmployeeResult(response); break;
				case 'showInventoryTemplateResult': this.showInventoryTemplateResult(response); break;
				case 'showInventoryTemplateEmployeeResult': this.showInventoryTemplateEmployeeResult(response); break;
				case 'saveObjectInventoryTemplateDetailResult': this.saveObjectInventoryTemplateDetailResult(response); break;
				case 'saveInventoryTemplateStoreRackModuleProductsResult': this.saveInventoryTemplateStoreRackModuleProductsResult(response); break;
				case 'saveInventoryTemplateStoreRackModuleProductQuantityResult': this.saveInventoryTemplateStoreRackModuleProductQuantityResult(response); break;
				case 'updateInventoryTemplateDetailResult': this.updateInventoryTemplateDetailResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		saveInventoryTemplateStoreRackModuleProductsLocal() {
			this.saveInventoryTemplateStoreRackModuleProducts(this.objectInventoryTemplateStoreRackPoduleProducts)
		},
		saveInventoryTemplateStoreRackModuleProductsResultLocal(response) {
			if(response.data.success == true) {
				this.objectInventoryTemplate.inventory_template_store_rack_modules.forEach(item => {
					if(item.id == this.objectInventoryTemplateStoreRackPoduleProducts.inventory_template_store_rack_module_id) {
						response.data.data.store_rack_module_id = item.store_rack_module_id
						item.inventory_template_store_rack_module_products.push(response.data.data)
						this.$refs.btnCloseProductModal.click()
						this.clearObjectInventoryTemplateStoreRackPoduleProducts()
						setTimeout(() => {
							this.enterQuantity(response.data.data, this.forCode)
						}, 100)
					} 
				});
			}
		},
		saveInventoryTemplateStoreRackModuleProductQuantityLocal() {
			let index = this.objectInventoryTemplate.inventory_template_store_rack_modules.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectInventoryTemplateDetail.inventory_template_store_rack_module_id))
			if(index > -1) {
				this.objectInventoryTemplateDetail.store_rack_module_id = this.objectInventoryTemplate.inventory_template_store_rack_modules[index].store_rack_module_id
			}
			this.saveInventoryTemplateStoreRackModuleProductQuantity(this.objectInventoryTemplateDetail)
		},
		saveInventoryTemplateStoreRackModuleProductQuantityResultLocal(response) {
			if(response.data.success == true) {
				this.objectInventoryTemplate.inventory_template_store_rack_modules.forEach(item => {
					item.inventory_template_store_rack_module_products.forEach(product => {
						if(response.data.data.inventory_template_store_rack_module_product_id == product.id) {
							if(response.data.message == 'NEW') {
								product.inventory_template_store_rack_module_product_quantitys.push(response.data.data)
							} else if (response.data.message == 'UPDATED') {
								product.inventory_template_store_rack_module_product_quantitys.forEach(quantity => {
									if(quantity.id == response.data.data.id) {
										quantity.inventory_template_store_rack_module_product_id = response.data.data.inventory_template_store_rack_module_product_id
										quantity.store_rack_module_id = response.data.data.store_rack_module_id
										quantity.quantity = response.data.data.quantity
										quantity.employee_id = response.data.data.employee_id
										quantity.updated_at = response.data.data.updated_at
									}
								})
							}
						}
					});
				});
			}
			this.searchProduct = ''
			this.$refs.btnCloseEnterQuantityModal.click()
			if(this.forCode) {
				setTimeout(() => {
					this.$refs.labelSearchProduct.click()
				}, 100)
			}
		},
		showInventoryTemplateEmployeeLocal(id) {
			this.inventoryTemplateSelected = id
			this.showInventoryTemplate(this.inventoryTemplateSelected, 1)
		},
		showInventoryTemplateResultLocal(response) {
			if(response.data.success == true) {
				this.setObjectInventoryTemplate(response.data.data)
				this.countIndexEmployee = 0
				for(let i = 1; i < 5 ; i++) {
					if(this.isEmployeeCount(i)) {
						this.countIndexEmployee = i		
					}
				}
				this.countIndexEmployee
				if(this.objectInventoryTemplate.inventory_template_store_rack_side_row_column.length > 0) {
					this.storeRackSideIdSelected = this.objectInventoryTemplate.inventory_template_store_rack_side_row_column[0].store_rack_side_id
					setTimeout(() => {this.$refs.sideComponent.$refs.btnGetStoreRackSide.click()}, 100)
				}
			}
		},
		setObjectEmployeeLocal(employee) {
			this.setObjectEmployee(employee)
		},
		verifyCode() {
			if((this.searchProduct.trim().length == 13 || this.searchProduct.trim().length == 10) && !isNaN(this.searchProduct.trim())) {
				return 1
			} else if(this.searchProduct.trim().length > 1 && this.searchProduct.trim().substring(0,1).toLowerCase() == 'h' && !isNaN(this.searchProduct.trim().substring(1, this.searchProduct.trim().length))) {
				return 2
			}

			return 0
		},
		checkCode() {
			let index = -1
			if(this.verifyCode() == 1) {
				index = this.listIntentoryTemplateProducts.map((el) => (el.product.isbn + '')).indexOf(this.searchProduct.trim() + '')
				this.searchProducts = this.searchProduct.trim() + ''
			} else if(this.verifyCode() == 2) {
				index = this.listIntentoryTemplateProducts.map((el) => (parseInt(el.product.id))).indexOf(parseInt(this.searchProduct.trim().substring(1, this.searchProduct.trim().length)))
				this.searchProducts = parseInt(this.searchProduct.trim().substring(1, this.searchProduct.trim().length))
			} else {
				this.searchProducts = this.searchProduct.trim()
			}
			if(index > -1) {
				this.searchProducts = ''
				this.enterQuantity(this.listIntentoryTemplateProducts[index], true)
			} else {
				if(confirm('No existe nade en su planilla con "' + this.searchProducts + '", ¿Desea buscarlo para agregarlo?')) {
					this.getAllProducts(1)
				}
				this.searchProduct = ''
			}
		},
		saveObjectInventoryTemplateDetailLocal() {
			this.saveObjectInventoryTemplateDetail()
		},
		saveObjectInventoryTemplateDetailResultLocal(response) {
			if(response.data.success == true) {
				this.objectInventoryTemplate.inventory_template_detail.push(response.data.data)
				this.$refs.btnCloseAddProductModal.click()
				setTimeout(() => { 
					this.setObjectInventoryTemplateDetail(response.data.data)
					this.$refs.btnShowEnterQuantityModal.click()
				}, 500)
			} else {
				alert('Algo no salió bien')
				console.log(response)
			}
		},
		updateCount(index, item) {
			if(item['count_' + index] != null && item['count_' + index] != '') {
				this.updateInventoryTemplateDetailForCount(item.id, index, item['count_' + index])
			} else {
				if(item['count_' + index] != null) {
					alert('No se puede actualizar con este dato "'+ item['count_' + index] +'"')
					item['count_' + index] = ''
				}
			}
		},
		updateInventoryTemplateDetailResultLocal(response) {
			if(response.data.success == true) {
				this.$refs.btnCloseEnterQuantityModal.click()
				if(response.data.message == true) {
					this.updateListInventoryTemplateDetailLocal(response.data.data)
				}
			} else {
				alert('Algon no está funcionando')
				console.log(response.data)
			}
		},
		updateListInventoryTemplateDetailLocal(item) {
			let index = this.objectInventoryTemplate.inventory_template_detail.map(e => parseInt(e.id)).indexOf(parseInt(item.id))
			if(index > -1) {
				this.objectInventoryTemplate.inventory_template_detail[index].count_1 = item.count_1
				this.objectInventoryTemplate.inventory_template_detail[index].count_2 = item.count_2
				this.objectInventoryTemplate.inventory_template_detail[index].count_3 = item.count_3
				this.objectInventoryTemplate.inventory_template_detail[index].count_4 = item.count_4
				this.objectInventoryTemplate.inventory_template_detail[index].count_end = item.count_end
				this.objectInventoryTemplate.inventory_template_detail[index].updated_at_1 = item.updated_at_1
				this.objectInventoryTemplate.inventory_template_detail[index].updated_at_2 = item.updated_at_2
				this.objectInventoryTemplate.inventory_template_detail[index].updated_at_3 = item.updated_at_3
				this.objectInventoryTemplate.inventory_template_detail[index].updated_at_4 = item.updated_at_4
				this.objectInventoryTemplate.inventory_template_detail[index].updated_at_end = item.updated_at_end
			}
		}

	},
	mounted () {
		this.initComponentLocal()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
